import { Formik, Form } from "formik";
import { validationSchema } from "./validationSchema";
import { InfoSection } from "./Sections";

export function SharedForm(props) {
  return (
    <Formik
      initialValues={props.initialValues}
      validateOnMount={true}
      onSubmit={props.onSubmit}
      enableReinitialize={true}
      validationSchema={validationSchema}
    >
      {({ handleSubmit, isValid }) => (
        <Form onSubmit={handleSubmit}>
          {props.savebarRender({ handleSubmit, isValid })}
          <InfoSection />
        </Form>
      )}
    </Formik>
  );
}
